// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WPO4L","delete":"styles_delete__2iwVM","update":"styles_update__1dkhy","add":"styles_add__1Utkf"};